import React from "react";
import ImageSlider from "./ImageSlider";
import "./MultiImageSlider.css";

const images1 = [
  "/images/Frappucino.webp",
  "/images/MojitoBlue.webp",
  "/images/MojitoRed.webp",
];

const images2 = [
  "/images/CafRoyal.webp",
  "/images/BlueIce.webp",
  "/images/Gateau1.webp",
];

const images3 = [
  "/images/Crêpe fond.webp",
  "/images/PetitDejGourmand.webp",
  "/images/Assida.webp",
  "/images/omelette.webp",
];

const MultiImageSlider = () => {
  return (
    <div className="multi-image-slider">
      <ImageSlider images={images1} interval={2000} />
      <ImageSlider images={images2} interval={2500} />
      <ImageSlider images={images3} interval={3000} />
    </div>
  );
};

export default MultiImageSlider;